import type { Table } from "@tanstack/react-table";
import type { IUsuario } from "../../../modelos/Usuario/entidades/IUsuario";
import type { IFiltroUsuario } from "../../../modelos/Usuario/entidades/IFiltroUsuario";
import type { ICiudad } from "../../../modelos/Ubicacion/entidades/ICiudad";
import type { IRegional } from "../../../modelos/Regionales/entidades/IRegional";
import type { IZona } from "../../../modelos/Zonas/entidades/IZona";
import type { IPais } from "../../../modelos/Ubicacion/entidades/IPais";

export interface ITablaUsuariosVistaProps {
    tabla: Table<IUsuario>;
    filtro: IFiltroUsuario;
    consultarUsuarios: (filtro: IFiltroUsuario) => void;
    manejarCambioFiltroUsuario: (campo: keyof IFiltroUsuario, valor: IFiltroUsuario[keyof IFiltroUsuario]) => void;
    limpiarFiltros: () => void;
    entidadesFiltro: IEntidadesFiltroUsuario;
    habilitarFiltros: boolean;
    manejarHabilitarFiltros: (habilitar: boolean) => void;
}

export const estadoInicialUsuario: IUsuario = {
    Id: 0,
    Email: "",
    NombreCompleto: "",
    Identificacion: "",
    PaisId: 0,
    CiudadId: 0,
    RegionalId: 0,
    ZonaId: 0,
    Ruta: "",
    PerfilUsuarioId: 0,
    TipoTecnicoId: 0,
    Telefono: "",
    Activo: true,
    Eliminado: false,
    CreadoUtc: new Date().toISOString(),
    ActualizadoUtc: new Date().toISOString()
};

export const estadoInicialFiltroUsuario: IFiltroUsuario = {
    Nombre: undefined,
    Email: undefined,
    CiudadId: undefined,
    PaisId: undefined,
    RegionalId: undefined,
    ZonaId: undefined,
}

export interface IEntidadesFiltroUsuario {
    Paises: IPais[];
    Ciudades: ICiudad[];
    CiudadesFiltro: ICiudad[];
    Regionales: IRegional[];
    RegionalesFiltro: IRegional[];
    Zonas: IZona[];
}

export interface IUsuariosCVProps {
}

export interface IFiltroUsuariosVistaProps {
    filtro: IFiltroUsuario;
    consultarUsuarios: (filtro: IFiltroUsuario) => void;
    manejarCambioFiltroUsuario: (campo: keyof IFiltroUsuario, valor: IFiltroUsuario[keyof IFiltroUsuario]) => void;
    limpiarFiltros: () => void;
    entidadesFiltro: IEntidadesFiltroUsuario;
}
